import ISavedStateData from "./ISavedStateData";
import {BaseModel} from "../../core/src/model/BaseModel";

class SavedStateModel extends BaseModel<ISavedStateData> {
    public accumulatedWin:number = 0;
    public currentStep:number = 0;

}

export default new SavedStateModel();